export class SignInRequest {
  public username: string = '';
  public password: string = '';
}
